import Listing from "./scripts/components/Listing";
import { format } from "date-fns";

class NewsListing {
    constructor(element) {
        this.el = element;
        this.form = document.getElementById("news-filters-form");
        this.intervals = document.querySelectorAll('[name="interval"]');
        this.labelFieldRadios = this.form.querySelectorAll(
            `.filter-button--radio`,
        );

        this.init();
    }

    init() {
        if (this.el) {
            this.listing = new Listing({
                root: this.el,
                form: this.form,
                listingId: "news",
                promoInterval: 4,
                pagination: {
                    type: "numbered",
                    perPage: 18,
                },
                html: "/wp-content/uploads/news.html",
                json: "/wp-content/uploads/news.json",
                objectName: {
                    singular: "article",
                    plural: "articles",
                },
                callback: () => {
                    // console.log("[NewListing]: ", this.listing);
                },
            });
        }
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const element = document.getElementById("news-listing");

    if (element) {
        new NewsListing(element);
    }
});
